import React from "react";
import PageLayout from "../../templates/page";
import { useMediaQuery, Flex } from "discover.medical.react-component-library";
import {
  StyledTOCHolder,
  StyledContentHolder,
  StyledHeading
} from "./_.styled";
import TableOfContents from "./TableOfContents";
import { Heading } from "./components";
import { content } from "./content";

export const AboutPage = () => {
  const maxMdMq = useMediaQuery("max", "md");

  return (
    <PageLayout>
      <StyledHeading element="h1" color="gray800" fontFamily="secondary">
        {content.heading}
      </StyledHeading>
      <Flex
        noGap
        container
        column={maxMdMq}
        justify={{ content: "space-between" }}
      >
        <StyledTOCHolder cell minWidth="25%">
          <TableOfContents list={content.sections} />
        </StyledTOCHolder>
        <StyledContentHolder cell column>
          {content.sections.map(section => (
            <React.Fragment key={section.id}>
              <Heading id={section.id}>{section.label}</Heading>
              {section.content}
            </React.Fragment>
          ))}
        </StyledContentHolder>
      </Flex>
    </PageLayout>
  );
};
